import { useEffect } from 'react';


const Curriculum = ({ curriculumSection }) => {
 
  if (!curriculumSection) return null;

  return (
    <section className="mb-3">
      <div className="container">
        <h2 className="sec-title text-center" >
          {curriculumSection.title}
        </h2>
        <ul className="list-unstyled">
          {curriculumSection.points?.map((point, index) => (
            <li key={index} className="mb-3" >
              {point.prefix_type === 'number' ? (
                <strong style={{ color: 'var(--thm-bg)' }}>{point.prefix_value} </strong>
              ) : (
                <i className={`fa ${point.prefix_value} me-2`}></i>
              )}
              {point.text}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Curriculum;
